export default __webpack_public_path__ + "static/media/Mumbai.1249b7d8.jpg";